import {Component, OnInit, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import {Ordered} from 'src/app/models/ordered';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {OrderedService} from 'src/app/services/ordered.service';
import {FormGroup, FormControl, FormBuilder, FormGroupDirective, NgForm} from '@angular/forms';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-annuity-viewer-dialog',
  templateUrl: './annuity-viewer-dialog.component.html',
  styleUrls: [ './annuity-viewer-dialog.component.scss' ]
})
export class AnnuityViewerDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();

  public ordered: Ordered = new Ordered()
  public new_order: boolean = false;
  public order_date: any;

  public payment_type_display: string;
  public valor_liquido: any;
  public tax: number = 0;

  public entityForm: FormGroup;

  public dt_refunded: any;

  public new_order_inserted: boolean = false;

  constructor (
    private fb: FormBuilder,
    private snackBar: SnackBarIconService,
    public _orderedService: OrderedService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.ordered = this.data.ordered;
  }

  ngOnInit () {

    this.entityForm = this.createForm()
    this.setFormValues(this.ordered, this.entityForm)

    this.new_order = this.data.new_order

    this.order_date = this.ordered.date
    if (this.order_date.seconds) {
      this.order_date = new Date(this.order_date.seconds * 1000)
    } else {
      this.order_date = this.ordered.date
    }

    if (this.data.ordered.payment_type == "cartao" || this.data.ordered.payment_type == "CreditCard") {

      this.payment_type_display = "Cartão de Crédito"

      if (this.data.ordered.card_installments == 1) {
        this.tax = 0.037
      } else {
        this.tax = 0.047
      }
    } else if (this.data.ordered.payment_type == "Billet") {

      this.payment_type_display = "Boleto Bancário"

    } else if (this.data.ordered.payment_type == "Free") {

      this.payment_type_display = "Cortesia"
      this.tax = 0

    } else if (this.data.ordered.payment_type == "Cash") {

      this.payment_type_display = "Dinheiro"
      this.tax = 0

    }

    let debit = Number(this.data.ordered.member_debit)
    let value = Number(this.data.ordered.value)

    let tax_value = this.tax * (debit + value)
    this.valor_liquido = this.data.ordered.total - tax_value

    if (this.data.ordered.refund_date) {
      this.dt_refunded = new Date(this.data.ordered.refund_date.seconds * 1000)
    } else {
      this.dt_refunded = null
    }

  }

  createForm () {
    let form: FormGroup = this.fb.group({
      Tid: new FormControl(''),
      value: new FormControl(''),
      discount: new FormControl(''),
      tax: new FormControl(''),
      total_minus_tax: new FormControl('')
    });

    return form
  }

  setFormValues (data, form) {
    form.controls.Tid.setValue(data.Tid);
    form.controls.value.setValue(data.value || 0);
    form.controls.discount.setValue(data.discount || 0);
    form.controls.tax.setValue(data.tax || 0);
    form.controls.total_minus_tax.setValue(data.total_minus_tax || 0);
  }

  updateOrder () {

    this._orderedService.spinner = true;

    const updatedOrder = {
      'Tid': this.entityForm.controls.Tid.value,
      'value': this.entityForm.controls.value.value,
      'total': this.entityForm.controls.value.value,
      'discount': this.entityForm.controls.discount.value,
      'tax': this.entityForm.controls.tax.value,
      'total_minus_tax': this.entityForm.controls.total_minus_tax.value
    }

    this._orderedService.updateOrder(this.ordered.id, updatedOrder)
      .then((e) => {
        this.new_order_inserted = true;
        this.snackBar.openSnackBar("Sucesso!", '', 'success')
      })
      .catch((error) => {
        console.log("error insert ordered")
        this.snackBar.openSnackBar("Erro!", '', 'error')
      })
      .finally(() => {
        this._orderedService.spinner = false;
      })

  }

  calcValue () {
    let value = this.entityForm.controls.value.value;
    let discount = this.entityForm.controls.discount.value;
    let tax = this.entityForm.controls.tax.value;
    //let total_minus_tax = this.entityForm.controls.total_minus_tax.value;
    let subtotal: number = 0;
    //let taxValue: number = 0;

    // console.log("value: " + value);
    // console.log("discount: " + discount);
    // console.log("tax: " + tax);

    if (value) {
      subtotal = value

      if (discount) {
        subtotal = value - discount
      }

      this.entityForm.controls.total_minus_tax.setValue(subtotal);

    }

  }

}


